/*
 * ELDR Food Ordering Hours — shared, read-only helper.
 *
 * Single source of truth for "is ELDR food/drink pickup ordering open right
 * now" and "which real Shopify products count as food/drink ordering."
 * Loaded by the isolated food-ordering surfaces only (Food Menu page,
 * Smoothie/Frozen Yogurt Bowl/Hydrators/Power Bites/Build Your Own Bowl
 * product pages, and the cart page/drawer gate) — never loaded on, or
 * referenced by, any supplement page. Does not touch theme.js,
 * main-product.liquid, or any shared cart/checkout markup itself; other
 * scripts read window.ELDRFoodHours and disable/warn on their own buttons.
 *
 * Time is computed from Intl's IANA timezone database (America/Vancouver),
 * never the visitor's device timezone and never a hard-coded PST/PDT
 * offset — this is what makes daylight saving time correct automatically,
 * on both sides of the spring/fall transition, with no manual date math.
 *
 * Window: 10:00 AM (inclusive) through 5:00 PM (exclusive) Pacific, every
 * day. 5:00:00 PM itself is CLOSED.
 */
window.ELDRFoodHours = (function () {
  var TIMEZONE = 'America/Vancouver';
  var OPEN_MINUTES = 10 * 60; // 10:00 AM
  var CLOSE_MINUTES = 17 * 60; // 5:00 PM, exclusive

  // Real Shopify product handles that make up ELDR's made-in-house food/drink
  // ordering. Add a new handle here (and nowhere else) when a new food/drink
  // item launches, e.g. Hot Bowls. Never matched against supplement products.
  var FOOD_HANDLES = [
    'smoothie-regular-20-oz', // Smoothies
    'frozen-yogurt-bowl', // Açaí + Frozen Yogurt Bowls (preset)
    'eldr-hydrators', // ELDR Hydrators
    'eldr-power-bites', // Power Bites
    'build-your-own-bowl', // Build Your Own Bowl bases/toppings
    'smoothie-add-on', // Smoothie Add Ons (functional boosts)
    'untitled-jun18_14-26-25' // Frozen Yogurt Add Ons (bowl toppings)
  ];

  var HOURS_TEXT = 'Online ordering available daily\n10 AM – 5 PM Pacific Time';
  var CLOSED_LABEL = 'Online Ordering Closed';

  function pacificMinutesNow() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: TIMEZONE,
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    });
    var hour = 0;
    var minute = 0;
    fmt.formatToParts(new Date()).forEach(function (part) {
      if (part.type === 'hour') hour = parseInt(part.value, 10);
      if (part.type === 'minute') minute = parseInt(part.value, 10);
    });
    // Some engines report midnight as hour "24" for this timezone/locale
    // combination; normalize so the minutes-since-midnight math stays correct.
    if (hour === 24) hour = 0;
    return hour * 60 + minute;
  }

  function isOpen() {
    var minutesNow = pacificMinutesNow();
    return minutesNow >= OPEN_MINUTES && minutesNow < CLOSE_MINUTES;
  }

  function isFoodHandle(handle) {
    return FOOD_HANDLES.indexOf(handle) !== -1;
  }

  // Calls `callback(open)` immediately, then again every time open/closed
  // actually changes (checked every 20s) — cheap, and correct for a
  // customer who leaves a tab open across the open/close boundary.
  function watch(callback) {
    var last = null;
    function tick() {
      var open = isOpen();
      if (open !== last) {
        last = open;
        callback(open);
      }
    }
    tick();
    return setInterval(tick, 20000);
  }

  return {
    isOpen: isOpen,
    isFoodHandle: isFoodHandle,
    watch: watch,
    FOOD_HANDLES: FOOD_HANDLES,
    HOURS_TEXT: HOURS_TEXT,
    CLOSED_LABEL: CLOSED_LABEL
  };
})();
